import MicroModal from 'micromodal';
// import { getSelectedVariantByIdJson } from './helpers';
/**
 * Delivery Estimate
 * 
 * This script handles the delivery estimate functionality for the product page.
 */
export default class DeliveryEstimate {
  static inFlightByKey = {};

  deliveryEstimateProxyURL;
  elements;
  customerData;
  requestData;
  dataExpirationHours;
  fasterRates = [];
  allRates = [];
  groundDateLabel = '';
  zipCode = '';

  constructor() {
    this.deliveryEstimateProxyURL = `/apps/delivery-estimates/retrieve-delivery-estimates`;
    this.dataExpirationHours = 1;

    this.elements = {
      delivery_estimate: document.querySelector('[data-delivery-estimate]'),
    };

    if (!this.elements.delivery_estimate) {
      return;
    }

    this.customerData = null;
    this.requestData = {};

    this.init();
  }

  init = async () => {
    const delivery_estimate = localStorage.getItem('delivery-estimate-data');
    if (delivery_estimate) {
      const delivery_estimate_json = JSON.parse(delivery_estimate);
      const isExpired = delivery_estimate_json.timestamp && (Date.now() - delivery_estimate_json.timestamp > (this.dataExpirationHours * 60 * 60 * 1000));

      if (delivery_estimate_json.shippingRates && delivery_estimate_json.userLocationData && !isExpired) {
        this.updateDeliveryEstimate(delivery_estimate_json);
        return;
      } else {
        localStorage.removeItem('delivery-estimate-data');
      }
    }

    this.initData();
    await this.retrieveAppProxyData();
    this.initFrontend();
  };

  initData = () => {
    // Get the weight from the selected variant
    // const selectedVariant = getSelectedVariantByIdJson();

    // if (selectedVariant) {
    //   this.requestData.product_weight = (!selectedVariant.weight || selectedVariant.weight === '0') ? 1.5 : selectedVariant.weight;
    // }

    // Get the customer data from the logged in customer
    const customerDataJson = document.querySelector('[data-customer-data-json]');
    if (customerDataJson) {
      this.customerData = JSON.parse(customerDataJson.innerHTML);
    }

    if (this.customerData) {
      // Save to local storage
      window.localStorage.setItem('delivery-estimate-data', JSON.stringify({
        customer_address: this.customerData.street || '',
        customer_city: this.customerData.city || '',
        customer_zip: this.customerData.zip || '',
        customer_province_code: this.customerData.province_code || '',
        customer_country_code: this.customerData.country_code || '',
        timestamp: Date.now(),
      }));
    }

    // Get the customer data from local storage
    const storedDeliveryEstimateDataRaw = window.localStorage.getItem('delivery-estimate-data') || null;
    const storedDeliveryEstimateData = storedDeliveryEstimateDataRaw ? JSON.parse(storedDeliveryEstimateDataRaw) : null;
    if (storedDeliveryEstimateData) {
      this.requestData.customer_address = storedDeliveryEstimateData.customer_address || '';
      this.requestData.customer_city = storedDeliveryEstimateData.customer_city || '';
      this.requestData.customer_zip = storedDeliveryEstimateData.customer_zip || '';
      this.requestData.customer_province_code = storedDeliveryEstimateData.customer_province_code || '';
      this.requestData.customer_country_code = storedDeliveryEstimateData.customer_country_code || '';
    }
  };

  getRequestKey = () => {
    const normalizedData = {
      customer_address: (this.requestData.customer_address || '').trim().toLowerCase(),
      customer_city: (this.requestData.customer_city || '').trim().toLowerCase(),
      customer_zip: (this.requestData.customer_zip || '').trim(),
      customer_province_code: (this.requestData.customer_province_code || '').trim().toUpperCase(),
      customer_country_code: (this.requestData.customer_country_code || '').trim().toUpperCase(),
    };

    return JSON.stringify(normalizedData);
  };

  getCachedEstimateForRequest = (requestKey) => {
    const deliveryEstimateRaw = window.localStorage.getItem('delivery-estimate-data');
    if (!deliveryEstimateRaw) return null;

    const deliveryEstimate = JSON.parse(deliveryEstimateRaw);
    const isExpired = deliveryEstimate.timestamp && (Date.now() - deliveryEstimate.timestamp > (this.dataExpirationHours * 60 * 60 * 1000));
    const hasRequiredData = Boolean(deliveryEstimate.shippingRates && deliveryEstimate.userLocationData);

    if (!hasRequiredData || isExpired) {
      return null;
    }

    // If request keys are available, use them to prevent re-fetching the same location payload.
    if (deliveryEstimate.requestKey && deliveryEstimate.requestKey !== requestKey) {
      return null;
    }

    return deliveryEstimate;
  };

  retrieveAppProxyData = async () => {
    const requestKey = this.getRequestKey();
    const cachedEstimate = this.getCachedEstimateForRequest(requestKey);

    if (cachedEstimate) {
      return cachedEstimate;
    }

    if (DeliveryEstimate.inFlightByKey[requestKey]) {
      return DeliveryEstimate.inFlightByKey[requestKey];
    }

    const proxyURL = (window.Shopify.shop.includes('dev-')) ? `https://da80-70-93-176-254.ngrok-free.app/v1/retrieve-delivery-estimates` : this.deliveryEstimateProxyURL;
    const requestPromise = (async () => {
      const response = await fetch(`${proxyURL}${window.theme.customer.app_signature}`, {
        method: 'POST',
        body: JSON.stringify(this.requestData),
      });

      if (!response.ok) {
        const error_message = await response.json();
        console.error(error_message);
        return null;
        // throw new Error(error_message.Error);
      }

      const json = await response.json();
      console.log('[ASTR] delivery-estimate-data: ', json);

      // Save to local storage with timestamp
      const dataToStore = {
        ...json,
        timestamp: Date.now(),
        requestKey,
      };
      window.localStorage.setItem('delivery-estimate-data', JSON.stringify(dataToStore));

      return dataToStore;
    })();

    DeliveryEstimate.inFlightByKey[requestKey] = requestPromise;

    try {
      return await requestPromise;
    } finally {
      delete DeliveryEstimate.inFlightByKey[requestKey];
    }
  };

  initFrontend = () => {
    // Retrieve the delivery estimate from local storage
    const delivery_estimate = window.localStorage.getItem('delivery-estimate-data');
    if (delivery_estimate) {
      const delivery_estimate_json = JSON.parse(delivery_estimate);
      if (!delivery_estimate_json.shippingRates || !delivery_estimate_json.userLocationData) {
        return;
      }

      this.updateDeliveryEstimate(delivery_estimate_json);
    }
  };

  updateDeliveryEstimate = (delivery_estimate) => {
    /*
    {
      "shippingRates": [
        {
            "serviceType": "STANDARD_OVERNIGHT",
            "deliveryDate": {
                "dayOfWeek": "Tue",
                "dayFormat": "2026-03-10T17:00:00"
            }
        },
        {
            "serviceType": "FEDEX_2_DAY",
            "deliveryDate": {
                "dayOfWeek": "Wed",
                "dayFormat": "2026-03-11T17:00:00"
            }
        },
        {
            "serviceType": "FEDEX_GROUND",
            "deliveryDate": {
                "dayOfWeek": "Tue",
                "dayFormat": "2026-03-10T23:59:00"
            }
        }
      ],
      "userLocationData": {
        "customer_address": "123 Main St",
        "customer_city": "Los Angeles",
        "customer_zip": "90001",
        "customer_province_code": "CA",
        "customer_country_code": "US"
      }
    }
    */

    let delivery_estimate_html = '';
    this.zipCode = delivery_estimate.userLocationData.customer_zip;

    // Retrieve the ground delivery estimate
    const ground_delivery_estimate = delivery_estimate.shippingRates ? delivery_estimate.shippingRates.find((item) => item.serviceType === 'FEDEX_GROUND') : null;

    if (!ground_delivery_estimate) {
      this.allRates = [];
      this.fasterRates = [];
      delivery_estimate_html = `
        <span class="delivery-estimate__text">No shipping methods available for <span class="delivery-estimate__zip no-themed" data-zip role="button" tabindex="0">${this.zipCode}</span></span>
      `;
      this.elements.delivery_estimate.innerHTML = delivery_estimate_html;
      this.elements.delivery_estimate.classList.add('active');
      this.initFrontendEvents();
      return;
    }

    const groundDate = new Date(ground_delivery_estimate.deliveryDate.dayFormat);
    groundDate.setHours(0, 0, 0, 0);
    const enableCountdown = this.elements.delivery_estimate.dataset.enableCountdown === 'true';
    this.groundDateLabel = `${ground_delivery_estimate.deliveryDate.dayOfWeek}, ${groundDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} to <span class="delivery-estimate__zip no-themed" data-zip role="button" tabindex="0">${this.zipCode}</span>`;

    // US holidays for 2026–2030
    const US_HOLIDAYS = new Set([
      // 2026
      '1/1/2026', '5/25/2026', '6/19/2026',
      '7/3/2026', '9/7/2026', '10/12/2026', '11/11/2026', '11/26/2026', '12/25/2026',
      // 2027
      '1/1/2027', '5/31/2027', '6/18/2027',
      '7/5/2027', '9/6/2027', '10/11/2027', '11/11/2027', '11/25/2027', '12/24/2027', '12/31/2027',
      // 2028
      '5/29/2028', '6/19/2028',
      '7/4/2028', '9/4/2028', '10/9/2028', '11/10/2028', '11/23/2028', '12/25/2028',
      // 2029
      '1/1/2029', '5/28/2029', '6/19/2029',
      '7/4/2029', '9/3/2029', '10/8/2029', '11/12/2029', '11/22/2029', '12/25/2029',
      // 2030
      '1/1/2030', '5/27/2030', '6/19/2030',
      '7/4/2030', '9/2/2030', '10/14/2030', '11/11/2030', '11/28/2030', '12/25/2030',
    ]);

    // Returns the UTC Date of the next valid 12 PM Pacific cutoff on a business day
    const getNextCutoff = () => {
      const now = new Date();
      for (let d = 0; d <= 7; d++) {
        const candidate = new Date(now.getTime() + d * 864e5);
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles',
          year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short',
        }).formatToParts(candidate);
        const get = (type) => parts.find(p => p.type === type).value;
        const weekday = get('weekday');
        const m = parseInt(get('month')), day = parseInt(get('day')), y = parseInt(get('year'));

        if (weekday === 'Sun' || weekday === 'Sat') continue;
        if (US_HOLIDAYS.has(`${m}/${day}/${y}`)) continue;

        // Determine Pacific offset at 20:00 UTC (noon Pacific ≈ 19–20 UTC): PDT = -07, PST = -08
        const noonUTC = new Date(`${y}-${String(m).padStart(2, '0')}-${String(day).padStart(2, '0')}T20:00:00Z`);
        const ptNoonHour = parseInt(new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles', hour: '2-digit', hour12: false,
        }).format(noonUTC));
        const offset = ptNoonHour === 13 ? '-07:00' : '-08:00';

        const cutoff = new Date(`${y}-${String(m).padStart(2, '0')}-${String(day).padStart(2, '0')}T12:00:00${offset}`);
        if (cutoff > now) return cutoff;
      }
      return null;
    };

    const msUntilCutoff = () => {
      const cutoff = getNextCutoff();
      return cutoff ? cutoff - new Date() : 0;
    };

    const countdownText = () => {
      const ms = msUntilCutoff();
      const totalMinutes = Math.floor(ms / 60000);
      const h = Math.floor(totalMinutes / 60);
      const m = totalMinutes % 60;
      return `Order within <strong>${h}h ${m}m</strong> to get it by ${this.groundDateLabel}`;
    };

    const showCountdown = enableCountdown && msUntilCutoff() > 0 && msUntilCutoff() <= 8 * 60 * 60 * 1000;
    const groundText = showCountdown
      ? countdownText()
      : `Arrives by ${this.groundDateLabel}`;

    delivery_estimate_html += `
      <span class="delivery-estimate__text">${showCountdown ? `<span data-delivery-estimate-countdown>${groundText}</span>` : groundText}</span>
    `;

    // Update order to reflect: 1) FEDEX_GROUND 2) FEDEX_2_DAY 3) STANDARD_OVERNIGHT
    this.allRates = delivery_estimate.shippingRates.sort((a, b) => {
      const serviceTypeOrder = {
        'FEDEX_GROUND': 1,
        'FEDEX_2_DAY': 2,
        'STANDARD_OVERNIGHT': 3
      };
      return serviceTypeOrder[a.serviceType] - serviceTypeOrder[b.serviceType];
    });

    const orderedShippingRates = this.allRates;

    // Disabled by request - Only include expedited options that arrive strictly before ground shipping (date only, no time)
    this.fasterRates = orderedShippingRates.filter((item) => {
      if (item.serviceType === 'FEDEX_GROUND') return false;
      // const itemDate = new Date(item.deliveryDate.dayFormat);
      // itemDate.setHours(0, 0, 0, 0);
      // return itemDate < groundDate;
      return true;
    });

    if (this.fasterRates.length > 0) {
      delivery_estimate_html += `<span class="delivery-estimate__link" data-delivery-estimate-link aria-expanded="false" aria-controls="delivery-estimate-list" role="button" tabindex="0">Faster shipping options</span>`;
    }

    this.elements.delivery_estimate.innerHTML = delivery_estimate_html;
    this.elements.delivery_estimate.classList.add('active');

    // Start live countdown if enabled
    if (showCountdown) {
      if (this._countdownInterval) clearInterval(this._countdownInterval);
      this._countdownInterval = setInterval(() => {
        const el = this.elements.delivery_estimate.querySelector('[data-delivery-estimate-countdown]');
        if (!el) { clearInterval(this._countdownInterval); return; }
        if (msUntilCutoff() <= 0) {
          clearInterval(this._countdownInterval);
          el.closest('.delivery-estimate__text').innerHTML = `Arrives by ${this.groundDateLabel}`;
          return;
        }
        el.innerHTML = countdownText();
      }, 60000);
    }

    this.initFrontendEvents();
  };

  renderModalResults = () => {
    const modalResults = document.querySelector('[data-shipping-estimates-results]');
    if (!modalResults) return;

    let html = `
      <table class="shipping-estimates-modal__table">
        <thead>
          <tr>
            <th>Shipping Method</th>
            <th>Arrives By</th>
          </tr>
        </thead>
        <tbody>
    `;

    const groundRate = this.allRates.find((item) => item.serviceType === 'FEDEX_GROUND');
    const tableRates = groundRate ? [groundRate, ...this.fasterRates] : this.fasterRates;

    if (tableRates.length === 0) {
      html += `
        <tr>
          <td colspan="2" style="text-align: center; padding: 20px;">No shipping methods available for ${this.zipCode}</td>
        </tr>
      `;
    } else {
      tableRates.forEach((item) => {
        const date = new Date(item.deliveryDate.dayFormat);
        let serviceType = '';
        switch (item.serviceType) {
          case 'FEDEX_GROUND':
            serviceType = 'Ground Shipping';
            break;
          case 'STANDARD_OVERNIGHT':
            serviceType = 'Next Business Day';
            break;
          case 'FEDEX_2_DAY':
            serviceType = '2 Business Days';
            break;
        }
        html += `
          <tr>
            <td>${serviceType}</td>
            <td>${item.deliveryDate.dayOfWeek}, ${date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</td>
          </tr>
        `;
      });
    }

    html += `
        </tbody>
      </table>
    `;
    modalResults.innerHTML = html;
  };

  openShippingModal = (e) => {
    if (e) e.preventDefault();

    const zipInput = document.querySelector('#shipping-estimates-zip');
    if (zipInput && this.zipCode) {
      zipInput.value = this.zipCode;
    }

    this.renderModalResults();

    MicroModal.show('shipping-estimates-modal', {
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true
    });
  };

  initFrontendEvents = () => {
    if (!this.elements.delivery_estimate) {
      return;
    }

    // Use event delegation to handle clicks and keydown events on elements that might be replaced by the countdown
    this.elements.delivery_estimate.addEventListener('click', (e) => {
      const target = e.target.closest('[data-delivery-estimate-link], [data-zip]');
      if (target) {
        this.openShippingModal(e);
      }
    });

    this.elements.delivery_estimate.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const target = e.target.closest('[data-delivery-estimate-link], [data-zip]');
        if (target) {
          this.openShippingModal(e);
        }
      }
    });

    const modalForm = document.querySelector('.shipping-estimates-modal__form');
    if (modalForm) {
      modalForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const zipInput = modalForm.querySelector('#shipping-estimates-zip');
        const modalResults = document.querySelector('[data-shipping-estimates-results]');

        if (zipInput && zipInput.value) {
          const normalizedZip = zipInput.value.trim();

          // Avoid redundant API calls when the user submits the same ZIP already in use.
          if (normalizedZip && normalizedZip === this.zipCode) {
            this.renderModalResults();
            return;
          }

          if (modalResults) {
            modalResults.innerHTML = '<div class="shipping-estimates-modal__loading">Updating estimates...</div>';
          }

          // Update request data and fetch new estimates
          this.requestData.customer_zip = normalizedZip;
          // Clear other location data when updating via zip only to ensure consistency
          this.requestData.customer_address = '';
          this.requestData.customer_city = '';
          this.requestData.customer_province_code = '';
          this.requestData.customer_country_code = 'US'; // Assuming US for zip updates, or keep existing

          const updatedData = await this.retrieveAppProxyData();
          if (updatedData) {
            // updateDeliveryEstimate updates this.allRates and this.fasterRates
            this.updateDeliveryEstimate(updatedData);
            this.renderModalResults();
          } else if (modalResults) {
            modalResults.innerHTML = '<div class="shipping-estimates-modal__error">Error updating estimates. Please check your zip code and try again.</div>';
          }
        }
      });
    }
  };
}
